<template>
  <Layout style="background:#fff;">
    <Row>
      <i-col :md="24" v-for="(i, ix) in headers" :key="ix" class="items">
        <div v-if="i.value === 'available'">
          <span class="item">{{ i.text }}</span>
          <i-input :value="userinfo.available ? '正式用户' : '禁用/待审核'" readonly></i-input>
        </div>
        <div v-else-if="i.value === 'email'">
          <span class="item">{{ i.text }}</span>
          <i-input type='email' :value="userinfo.email" readonly></i-input>
        </div>
        <div v-else-if="i.value === 'sex'">
          <span class="item">{{ i.text }}</span>
          <i-switch v-model="userinfo.sex" style="margin-right:20px;" />
          <i-input :value="userinfo.sex ? '男' : '女'" readonly></i-input>
        </div>
        <div v-else-if="['name', 'username', 'phone', 'card', 'usergroup_name'].includes(i.value)">
          <span class="item">{{ i.text }}</span>
          <i-input v-model="userinfo[i.value]" readonly />
        </div>
        <div v-else-if="i.value === 'degree'">
          <span class="item">{{ i.text }}</span>
          <i-select v-model="userinfo.degree">
            <Option v-for="(i, ik) in user_field.degree" :key="ik" :value="Number(ik)" :label="i"></Option>
          </i-select>
        </div>
        <div v-else-if="i.value === 'user_number'">
          <span class="item">{{ i.text }}</span>
          <i-input :value="userinfo.user_number" readonly></i-input>
        </div>
      </i-col>
    </Row>
    <div>
      <Button type="primary" @click="confirmShow = true">修改</Button>
      <Button type="primary" @click="getUserinfo">刷新</Button>
    </div>
    <Modal v-model="confirmShow" @on-ok="save">
      <p>是否确定修改？</p>
    </Modal>
  </Layout>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "userInfo",
  data() {
    return {
      selected: [],
      headers: [
        { text: "用户名", value: "username" },
        { text: "姓名", value: "name" },
        { text: "组别", value: "usergroup_name" },
        { text: "工号", value: "user_number" },
        { text: "学历", value: "degree" },
        { text: "手机", value: "phone" },
        { text: "邮箱", value: "email" },
        { text: "卡号", value: "card" },
        { text: "性别", value: "sex" },
        { text: "用户类型", value: "user_type" },
        { text: "账户状态", value: "available" },
      ],
      userinfo: {},
      usergroups: [],
      loading: false,
      confirmShow: false,
      user_field: {
        available: { true: "正式用户", false: "禁用/未审核" },
        sex: { true: "男", false: "女" },
        degree: {
          0: "未知",
          1: "文盲",
          2: "小学",
          3: "初中",
          4: "高中/职高/中专",
          5: "专科",
          6: "本科",
          7: "在职硕士",
          8: "全日制硕士",
          9: "在职博士生",
          10: "全日制博士生",
        },
      },
    };
  },
  mounted() {
    this.getUserinfo();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapMutations(["setUser"]),
    getUserinfo() {
      this.db_api("post", '/api/account/userinfo', {
        req: "own_brief_info",
        id: this.user.id,
      }).then((r) => {
        this.userinfo = r[0].result[0];
      });
    },
    save() {
      this.db_api("post", this.api, { req: "set_userinfo", ...this.userinfo }).then(
        () => {
          this.$Notice.success({ title: "成功", desc: "个人信息修改成功！" });
          this.getUserinfo();
        }
      );
    },
  },
};
</script>

<style scoped>
.ivu-col {
  padding: 8px;
}

button {
  margin: 5px;
}

.items>div {
  display: flex;
  flex-direction: row;
  font-size: 16px;
}

.item {
  min-width: 20%;
  font-size: 18px;
}
</style>